import secureLocalStorage from "react-secure-storage";
import { SESSION } from "../api-routes/index";
import axiosInstance from "../../axiosConfig";
import mySessionStorage from "./sessionStorage.controllers";
import myLocalStorage from "./localStorage.controller";

const auth = (() => ({
  clear: () => {
		console.log('clear!!!!!!!!!!')
    secureLocalStorage.clear();
    sessionStorage.clear();
    history.pushState(null, "", "/");
  },
  create: token => {
    const creationTime = new Date().getTime();
    const threeMonthsInMilliseconds = 90 * 24 * 60 * 60 * 1000; // 90 días x 24 horas x 60 minutos x 60 segundos x 1000 milisegundos

    const expirationTime = creationTime + threeMonthsInMilliseconds;
    secureLocalStorage.setItem("expirationTime", expirationTime);
    secureLocalStorage.setItem("token", token);
  },

  logout: async () => {
    console.log(mySessionStorage.get("sessionWithCode"));
    if (mySessionStorage.get("sessionWithCode")) {
      mySessionStorage.remove("sessionWithCode");
      return false;
    }

    try {
      await axiosInstance.get(SESSION.SIGNOUT, {
        headers: {
          Authorization: `Token ${secureLocalStorage.getItem("token")}`
        }
      });
    } catch (error) {
      console.log(error);
    }
    auth.clear();
    return true;
  },
  checkTokenSavedAndValidated: async () => {
    const token = secureLocalStorage.getItem("token");
    const storedExpirationTime = secureLocalStorage.getItem("expirationTime");
    const currentTime = new Date().getTime();

    if (token) {
      if (currentTime <= storedExpirationTime) {
        return true;
      }

      const statusLogout = await auth.logout();

      if (!statusLogout) {
        return true;
      }
    }

    return false;
  }
}))();

export default auth;
